import { render, staticRenderFns } from "./MaterielList.vue?vue&type=template&id=6b633f0f&scoped=true"
import script from "./MaterielList.vue?vue&type=script&lang=js"
export * from "./MaterielList.vue?vue&type=script&lang=js"
import style0 from "./MaterielList.vue?vue&type=style&index=0&id=6b633f0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b633f0f",
  null
  
)

export default component.exports